import { ModuleSetting } from "@models";
import React from "react";

type ProductsPageContextValue = {
	moduleSettings: ModuleSetting[];
	triggerRefresh: () => void;
};

export default React.createContext<ProductsPageContextValue>({
	moduleSettings: [],
	triggerRefresh: () => {},
});
